import { Image } from '@chakra-ui/react';

interface CardImageProps {
  imageSource: string;
  alt: string;
}

// TODO: This component should be able to accept width and height props when imageSource is a URL (e.g contentful assets)
// However, this needs some type wrangling to ensure that an acceptable type like `number` without an `undefined` is passed down
// to next/image's width and height props.
const CardImage = ({ imageSource, alt }: CardImageProps) => {
  // if (typeof imageSource === 'string' && typeof imageWidth === 'number' && typeof imageHeight === 'number') {
  //   return <Image src={imageSource} alt={alt} sx={{ objectFit: 'cover' }} width={imageWidth} height={imageHeight} />;
  // }

  return <Image src={imageSource} alt={alt} fit="cover" height="100%" width="100%" />;
};

export { CardImage };
